import React from 'react'

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const CustomEditor = ({ content, setContent, height = 200, readOnly = false, allOptions = true }) => {

    // const config = useMemo(
    //     () => ({
    //         readonly: false,
    //         height: height,
    //         askBeforePasteHTML: false,
    //         placeholder: ""
    //     }),
    //     [] 
    // );

    const modules = {
        toolbar: [
            [{ 'font': [] }],  // Font dropdown
            [{ 'size': ['small', false, 'large', 'huge'] }],  // Size dropdown
            [{ 'align': [] }],  // Text alignment (left, center, right)
            ['bold', 'italic', 'underline'],  // Bold, italic, underline
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],  // Numbered and bulleted lists
            [{ 'color': [] }, { 'background': [] }],  // Font color and background color
            ['link'],  // Add link 
            ['blockquote'],  // Blockquote
            ['code-block'],  // Code block
            // ['image'],  // Code block
        ],
    };

    return (
        <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            {...(allOptions ? {modules: modules} : {placeholder:'Description '})}
            // modules={modules}
            readOnly={readOnly}
            style={{
                height: `${height}px`,
                marginBottom: '35px',
                paddingBottom: "10px"
            }} />
        // <JoditEditor
        //     value={content}
        //     config={config}
        //     askBeforePasteFromHTML={false}
        //     onChange={(newContent) => { setContent(newContent) }}
        // />
    )
}

export default CustomEditor